// extracted by mini-css-extract-plugin
module.exports = {"header":"Tabs_header_2-4UA","tab":"Tabs_tab_kYV-1","tabTitle":"Tabs_tabTitle_1-5DP","selected":"Tabs_selected_3hCcb","notSelected":"Tabs_notSelected_2OhUx"};